<template>
  <div class="row">
    <b-modal
      size="xl"
      id="modal-novo"
      ok-title="Salvar"
      ok-variant="success"
      title="Cadastrar novo projeto de gestão"
      @ok="salvarProjeto"
    >
      <projeto-gestao-detalhamento ref="formulario" />
    </b-modal>

    <b-card class="col-12" no-body>
      <div class="row">
        <div class="col-12 mb-3">
          <b-button
            variant="primary"
            @click="abrirModal"
            v-if="(this.endpoint == 'ProjetoGestao' && permissao.c) || ehAdmin"
            >Novo projeto de gestão / GPPDI</b-button
          >
        </div>
        <div class="col-12 row">
          <filtro-empresas
            class="col-12 col-md-4"
            v-if="ehAdmin"
            @update="buscarDados()"
          />
        </div>
        <b-table
          @row-dblclicked="abrirProjeto"
          head-variant="dark"
          class="col-12"
          :items="tabela.dados"
          :fields="tabela.colunas"
        >
          <template #cell(acoes)="data">
            <div class="d-flex">
              <b-button
                variant="flat-primary"
                v-if="permissao.r"
                @click="abrirProjeto(data.item)"
              >
                <i class="fas fa-edit"></i>
                
              </b-button>
              <b-button
                  v-if="permissao.r"
                  variant="flat-danger"
                  @click="excluirProjeto(data.item)"
                >
                  <i class="fa-solid fa-trash"></i>
                </b-button>
            </div>
          </template>
          <template #cell(status)="data">
            <div>
              <b-badge variant="info">
                {{ status(data.item.status) }}
              </b-badge>
            </div>
          </template>
        </b-table>
        <div class="col-12">
          <b-pagination
            v-model="tabela.paginaAtual"
            :total-rows="tabela.totalDeElementos"
            :per-page="tabela.itensPorPagina"
            @change="mudarPagina"
            align="center"
          ></b-pagination>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";

import ProjetoGestaoDetalhamento from "./accordions/detalhes";
export default {
  name: "ProjetoGestaoListagem",
  components: {
    ProjetoGestaoDetalhamento,
  },
  props: {
    endpoint: {
      type: String,
    },
    telaDetalhes: {
      type: String,
    },
  },
  data: () => ({
    tabela: {
      colunas: [
        { key: "codigo", label: "Cód. projeto" },
        {
          key: "dataInicio",
          label: "Data de inicio",
          formatter: (value) => (value ? helpers.formatarDataBr(value) : ""),
        },
        { key: "duracao", label: "Duração" },
        {
          key: "investimentoPrevistoNasRubricas",
          label: "Investimento Previsto",
          formatter: (value) => helpers.formatarValor(value),
        },
        {
          key: "investimentoRealizadoNasRubricas",
          label: "Investimento Realizado",
          formatter: (value) => helpers.formatarValor(value),
        },
        { key: "status", label: "Status" },
        { key: "acoes", label: "Ações" },
      ],
      dados: [],
      itensPorPagina: 10,
      paginaAtual: 0,
      totalDeElementos: 0,
    },
    empresas: [],
  }),
  methods: {
    status: function (status) {
      return helpers.getEnum(status).text;
    },
    abrirModal: function () {
      //this.$bvModal.show('modal-novo');
      this.$router.push({ name: "projeto-gestao-formulario" });
    },
    salvarProjeto: function (e) {
      e.preventDefault();
      this.$refs.formulario.salvar();
    },
    abrirProjeto: function (item) {
      ProjetoGestaoService.setEndpoint(item.endpoint);
      this.$router.push({ name: item.tela, params: { id: item.id } });
    },
    mudarPagina: function (pagina) {
      this.buscarDados(pagina - 1);
    },
    excluirProjeto: function (item) {
      this.confirmar(
        `Deseja seguir com a exclusão do projeto?`
      ).then((confirmado) => {
        if (!confirmado) return;

        ProjetoGestaoService.apagar(item.id)
          .then(() => {
            this.alertaSucesso(`Projeto excluído com sucesso!`).then(() => this.buscarDados());
          })
          .catch(() => {
            this.alertaErro(`Erro ao excluir projeto!`);
          });
      });
    },
    buscarDados: function (pagina = 0) {
      if (!this.empresaSelecionada) return;
      this.tabela.dados = [];
      this.tabela.totalDeElementos = 0;

      let endpoints = [{ end: this.endpoint, tela: this.telaDetalhes }];
      if (this.ehAdmin) {
        endpoints = [
          {
            end: "ProjetoGestao",
            tela: "projeto-gestao-proponente-detalhamento",
          },
          {
            end: "ProjetoGestaoCooperada",
            tela: "projeto-gestao-cooperada-detalhamento",
          },
        ];
      }

      this.$store.dispatch(START_LOADING);
      let totalEndpoints = endpoints.length;
      endpoints.forEach((elEndpoint) => {
        ProjetoGestaoService.setEndpoint(elEndpoint.end);
        ProjetoGestaoService.listarProjetos(
          this.empresaSelecionada,
          "",
          this.tabela.itensPorPagina,
          pagina
        )
          .then((res) => {
            this.tabela.dados.push(
              ...res.data.data.itens.map((el) => {
                if (elEndpoint.end != "ProjetoGestao") {
                  let id = el.id;
                  el.projetoGestao.endpoint = elEndpoint.end;
                  el.projetoGestao.tela = elEndpoint.tela;
                  el.projetoGestao.id = id;
                  return el.projetoGestao;
                }

                el.endpoint = elEndpoint.end;
                el.tela = elEndpoint.tela;
                return el;
              })
            );
            this.tabela.totalDeElementos += res.data.data.paginacao.totalDeElementos;
          })
          .finally(() => {
            totalEndpoints--;
            if (totalEndpoints == 0) {
              this.$store.dispatch(STOP_LOADING);
            }
          });
      });
    },
  },
  mounted: function () {
    this.buscarDados();
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: "Projetos de gestão / GPPDI" }]);
  },
  watch: {
    endpoint: function () {
      this.buscarDados();
    },
  },
  computed: {
    empresaSelecionada: function () {
      return this.$store.state.app.selectedCompanyObj.id;
    },
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("ProjetosGestao");
    },
  },
};
</script>
<style lang=""></style>
